import { render, staticRenderFns } from "./inspePlan.vue?vue&type=template&id=4c4f4f28&scoped=true"
import script from "./inspePlan.vue?vue&type=script&lang=js"
export * from "./inspePlan.vue?vue&type=script&lang=js"
import style0 from "./inspePlan.vue?vue&type=style&index=0&id=4c4f4f28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4f4f28",
  null
  
)

export default component.exports